(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "PropTypes", "classnames"], factory);
	else if(typeof exports === 'object')
		exports["orbitUIReact"] = factory(require("react"), require("prop-types"), require("classnames"));
	else
		root["orbitUIReact"] = factory(root["React"], root["PropTypes"], root["classnames"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__4639__, __WEBPACK_EXTERNAL_MODULE__3343__, __WEBPACK_EXTERNAL_MODULE__200__) => {
return 